import { MinusCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconMinusCircle(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <MinusCircle />
    </IconWrapper>
  );
}
